import { render, staticRenderFns } from "./chooseModel.vue?vue&type=template&id=72ebef04&scoped=true"
import script from "./chooseModel.vue?vue&type=script&lang=js"
export * from "./chooseModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebef04",
  null
  
)

export default component.exports